import { useMemo } from 'react'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import { buildPanelCheckItems } from 'components/Cruises/SearchPage/Filters/Inputs/CruiseExtraFiltersInputs'

interface Props {
  isLuxPlus?: Set<string>
  onChange: (nextFilters: Record<string, any>) => void
  luxPlusFacets: Array<App.CruiseSearchFacetV2Item>
}

function CruiseLuxPlusFilter({
  isLuxPlus,
  onChange,
  luxPlusFacets,
}: Props) {
  const luxPlusItems = useMemo(() => {
    return buildPanelCheckItems(luxPlusFacets)
  }, [luxPlusFacets])

  return <FilterPanelCheckboxGroup
    name="isLuxPlus"
    items={luxPlusItems}
    onChange={onChange}
    defaultSelected={isLuxPlus}
    maxValue={Number.POSITIVE_INFINITY}
  />
}

export default CruiseLuxPlusFilter
